import axios from "axios";
import { getToken } from "../utils/AuthService";
import { isLoggedIn } from "../redux/authSlice";
import { useSelector } from "react-redux";

const url = process.env.REACT_APP_PINEAPPLE_API_BACKEND_SERVER;

export const getProductList = async ({
  categoryId = "",
  brandId = "",
  subCategoryName = "",
  subCategoryTypeSlug = "",
  search = "",
  page,
  isOnFlashSale = "",
  isOnRedemption = "",
  isNewArrival = "",
  isTrending = "",
  isBestSelling = "",
  isSuperSaver = "",
  sort = "",
  minPrice = "",
  maxPrice = "",
  brandIds = [],
  subCategoryIds = []
}) => {

  const params = new URLSearchParams({
    filter: "Active",
    minPrice: minPrice || 0,
    maxPrice: maxPrice || 10000,
    limit: 12
  });

  if (categoryId) params.append("categorySlug", categoryId);
  if (brandId) params.append("brandSlug", brandId);
  if (subCategoryName) params.append("subCategorySlug", subCategoryName);
  if (subCategoryTypeSlug) params.append("subCategoryTypeSlug", subCategoryTypeSlug);
  if (search) params.append("search", search);
  if (page) params.append("page", page);
  if (sort) params.append("sort", sort);

  if (isOnFlashSale) params.append("isOnFlashSale", isOnFlashSale);
  if (isOnRedemption) params.append("isOnRedemption", isOnRedemption);
  if (isNewArrival) params.append("isNewArrival", isNewArrival);
  if (isTrending) params.append("isTrending", isTrending);
  if (isBestSelling) params.append("isBestSelling", isBestSelling);
  if (isSuperSaver) params.append("isSuperSaver", isSuperSaver);

  //  IMPORTANT PART
  if (typeof brandIds === "string" && brandIds.trim() !== "") {
    params.append("brandId", brandIds);
  }

  if (typeof subCategoryIds === "string" && subCategoryIds.trim() !== "") {
    params.append("subCategoryId", subCategoryIds);
  }

  const result = await axios.patch(
    `${url}/product/listWithSlug?${params.toString()}`
  );

  return result;
};


export const getProductListWithFilter = async ({
  categoryIds,
  minPrice,
  maxPrice,
  sort,
  isNewArrival,
  isTrending,
  isBestSelling,
  isSuperSaver,
  brandId,
  subCategoryName
}) => {
  try {
    const params = new URLSearchParams();

    // required
    params.append("filter", "Active");

    // optional filters
    if (categoryIds?.length) {
      params.append("categoryId", categoryIds.join(","));
    }

    params.append("minPrice", minPrice ?? 0);
    params.append("maxPrice", maxPrice ?? 0);

    if (sort) params.append("sort", sort);

    if (isNewArrival) params.append("isNewArrival", "true");
    if (isTrending) params.append("isTrending", "true");
    if (isBestSelling) params.append("isBestSelling", "true");
    if (isSuperSaver) params.append("isSuperSaver", "true");

    if (brandId) params.append("brandSlug", brandId);
    if (subCategoryName) params.append("subCategorySlug", subCategoryName);

    const result = await axios.patch(
      `${url}/product/list?${params.toString()}`
    );

    return result;
  } catch (err) {
    return Promise.reject(err?.response);
  }
};

export const getProductListForAddOnn = async ({
  categoryId = "",
  brandId = "",
  subCategoryName = "",
  subCategoryTypeSlug = "",
  search = "",
  page,
  isOnFlashSale,
  isOnRedemption,
  isNewArrival,
  isTrending,
  isBestSelling,
  isSuperSaver,
  sort = "",
  minPrice = 0,
  maxPrice = 10000,
  brandIds = [],
  subCategoryIds = []
}) => {

  const params = new URLSearchParams({
    filter: "Active",
    minPrice,
    maxPrice,
    limit: 12,
  });

  if (categoryId) params.append("categorySlug", categoryId);
  if (brandId) params.append("brandSlug", brandId);
  if (brandIds) params.append("brandId", brandIds);
  if (subCategoryName) params.append("subCategorySlug", subCategoryName);
  if (subCategoryIds) params.append("subCategoryId", subCategoryIds);
  if (subCategoryTypeSlug) params.append("subCategoryTypeSlug", subCategoryTypeSlug);
  if (isOnFlashSale) params.append("isOnFlashSale", true);
  if (isOnRedemption) params.append("isOnRedemption", true);
  if (isNewArrival) params.append("isNewArrival", true);
  if (isTrending) params.append("isTrending", true);
  if (isBestSelling) params.append("isBestSelling", true);
  if (isSuperSaver) params.append("isSuperSaver", true);
  if (sort) params.append("sort", sort);
  if (page) params.append("page", page);
  if (search) params.append("search", search);

  return axios.patch(`${url}/product/listWithSlug?${params.toString()}`);
};



export const getSingleProduct = async ({ productId }) => {
  try {
    const token = getToken();
    let result;
    if (token) {
      const { tokenAccess } = token;

      result = await axios.get(`${url}/product/get?slug=${productId}`, {
        headers: {
          Authorization: `Bearer ${tokenAccess}`,
          // foodauthtoken: `${foodAccessToken}`,
        },
      });
    } else {
      result = await axios.get(`${url}/product/get?slug=${productId}`);
    }
    return result;
  } catch (err) {
    console.log(err);
  }
};

export const getProductReview = async ({ productId }) => {
  try {
    const result = await axios.get(
      `${url}/product/reviews?productId=${productId}`
    );
    return result;
  } catch (err) {
    return Promise.reject(err?.response);
  }
};

export default getProductList;
